import axios, {} from "axios";
import { attachContentLanguageHeader } from "../config/contentLanguage";
import { creditsOnResponse, creditsOnResponseError, } from "./creditsInterceptor";
// import { setupInterceptorsTo } from "./interceptors";
// const instance = setupInterceptorsTo(
//   axios.create({
//     baseURL: import.meta.env.VITE_APP_BACKEND_URL,
//   }),
// );
const instance = axios.create();
// On the instance itself rather than in each host's onRequest so a new host
// cannot forget it. `en-US` is still sent; the backend treats it as default.
attachContentLanguageHeader(instance);
export const configureApi = (baseURL, onRequest, onResponse, onRequestError, onResponseError) => {
    instance.defaults.baseURL = baseURL;
    instance.interceptors.request.use(onRequest, onRequestError);
    /*
      Credit bookkeeping first, so the balance is applied before the app's own
      handler runs — web's 401 path redirects, and a balance read after that would
      be lost. It re-rejects, so the app's error handler still sees every failure.
    */
    instance.interceptors.response.use(creditsOnResponse, creditsOnResponseError);
    instance.interceptors.response.use(onResponse, onResponseError);
};
export default instance;
// Bootstrap config lives alongside configureApi so hosts configure everything
// from one import.
export { configureAssets, gameAssetUrl } from "../config/assets";
export { CONTENT_LANGUAGE_HEADER, CONTENT_LANGUAGE_NATIVE_NAMES, DEFAULT_CONTENT_LANGUAGE, SUPPORTED_CONTENT_LANGUAGES, adoptProfileContentLanguage, attachContentLanguageHeader, configureContentLanguage, configureContentLanguageStorage, contentLanguagePrimarySubtag, detectContentLanguage, getContentLanguage, getStoredContentLanguage, isContentLanguage, setContentLanguage, } from "../config/contentLanguage";
export { getPlayer } from "./players/getPlayer";
export {} from "./getManagerData";
export { getBaseData } from "./getBaseData";
export { getSbcSets } from "./sbcs/getSbcSets";
export { getSbcSet } from "./sbcs/getSbcSet";
export { getSbcs } from "./sbcs/getSbcs";
export { getObjectiveGroups, } from "./objectives/getObjectiveGroups";
export { getObjectiveGroup, } from "./objectives/getObjectiveGroup";
export { buildObjectiveBundle, buildObjectiveBundleStackedPlan, getLatestObjectiveBundle, getObjectiveBundle, getObjectiveSquads, markObjectiveSquadsSaved, revealObjectiveBundle, saveObjectiveBundleProgress, setObjectiveBlockMode, setObjectiveBundleView, startObjectiveSquads, } from "./objectives/objectiveBundles";
export { getPlayers } from "./players/getPlayers";
export { getEvolutions } from "./evolutions/getEvolutions";
export { getEvolutionSteps } from "./evolutions/getEvolutionSteps";
export { googleLogin } from "./login/googleLogin";
export { appleLogin } from "./login/appleLogin";
export { getProfile } from "./login/getProfile";
export { getCredits } from "./credits/getCredits";
export { deleteAccount } from "./login/deleteAccount";
export { verifyRevenueCatEntitlements } from "./payments/verifyRevenueCat";
export { createCustomerPortalSession } from "./payments/createCustomerPortalSession";
export { loginWithEmail } from "./login/loginWithEmail";
export { confirmLoginWithCode } from "./login/confirmCodeLogin";
export { markSbcSolved } from "./sbcs/markSbcSolved";
export { markSbcSetSolved } from "./sbcs/markSbcSetSolved";
export { markSbcSetAsFavorite } from "./sbcs/markSbcSetAsFavorite";
export { hideSbcSet } from "./sbcs/hideSbcSet";
export { undoVoteSbcSet, voteSbcSet } from "./sbcs/voteSbcSet";
export { putUserSbcSolution } from "./sbcs/putUserSbcSolution";
export { getUserSbcSolution } from "./sbcs/getUserSbcSolution";
export { solveSbc } from "./sbcs/solveSbc";
export { playerSwap } from "./sbcs/playerSwap";
export { deleteUserPlayers } from "./myClub/deleteUserPlayers";
export { deleteSpecificUserPlayers } from "./myClub/deleteSpecificUserPlayers";
export { postUserPlayers } from "./myClub/postUserPlayers";
export { postUserClubInfo } from "./myClub/postUserClubInfo";
export { unlinkClub } from "./myClub/unlinkClub";
export { postUserSquad } from "./userSquads/postUserSquad";
export { patchActiveSquad } from "./userSquads/patchActiveSquad";
export { patchEvolutionImportState } from "./userEvolutions/patchEvolutionImportState";
export { patchEvolutionStates } from "./userEvolutions/patchEvolutionStates";
export { submitFeedback, FEEDBACK_MAX_LENGTH, } from "./feedback/submitFeedback";
//# sourceMappingURL=api.js.map